import React from 'react'
import styled from 'styled-components'
import { Box, Heading } from 'rebass'
import media, { Absolute } from '../../../utils/style'

const ContentFrame = styled(Box)`
  width: 100%;
  background-color: ${(props) => props.bg};
  max-width: ${(props) => props.theme.content.max.width};
  position: relative;
  z-index: 1;
`

const ContentFrameWithShadow = styled(ContentFrame)`
  ${media.MediumScreenUp`
    &:before {
      content:'';
      position: absolute;
      z-index: -1;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 100%;
      box-shadow: 0 25px 25px 0px rgba(66,76,94,0.07),
      0 20px 20px 0 rgba(0,0,0,0.02);
    }
  `};
`

const CaseStudyDetails = styled(Box)`
  position: relative;
  background-color: ${(props) => props.theme.colors.blue_light};
  line-height: 1.5;
  color: ${(props) => props.theme.colors.grey_op80};
`

const CaseStudyImage = styled(({ theme, bgimg, ...rest }) => <Box {...rest} />)`
  @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
    only screen and (-o-min-device-pixel-ratio: 1.3/1),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) {
    background-image: url('${(props) => props.bgimg.x2}');
  }

  background-image: url(${(props) => props.bgimg.x1});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 78.048780488%;
  ${media.MediumScreenUp`
  padding-top: 0;
  `}
  order: ${(props) => props.order};
`

const CaseStudyLogo = styled(Absolute)`
  top: 0;
  right: 0;
`

const IndustryHeading = styled(Heading)`
  color: ${(props) => props.theme.colors.grey_light};
`

export {
  IndustryHeading,
  CaseStudyLogo,
  CaseStudyImage,
  CaseStudyDetails,
  ContentFrameWithShadow
}
